<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SP" @change="campaignSelectChange($event)" width="180px"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" adType="SP"></ad-group-select>
        <gj-select
            v-model="filter.status"
            :options="AdProductTargetEnum.SP.statusOptionNew"
            placeholder="状态"
        ></gj-select>
        <gj-select
                v-model="filter.strategyStatus"
                :options="AdStrategyStatusEnum.option"
                placeholder="分时策略"
        ></gj-select>
        <gj-lazy-input
            v-model="filter.keyword"
            placeholder="类别/ASIN"
            width="150px"
        ></gj-lazy-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/targets/export" :download-params="globalParams"
          >
          <template #before>
            <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
          </template>
          </gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add"
      >新增商品投放</gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdProductTargetEnum.SP.status.ARCHIVE)"
          @click="adjustBidAddPopup">
        应用建议竞价
      </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdProductTargetEnum.SP.status.ARCHIVE)"
          @click="adjustBid">
        调整竞价
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdProductTargetEnum.SP.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdProductTargetEnum.SP.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSpCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdProductTargetEnum.SP.status.ENABLE, AdProductTargetEnum.SP.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/targets/export" :download-params="globalParams"
      >
      <template #before>
        <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
      </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSpCampaigns:addOrUpdate')"
          size="has-picture"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :show-header-overflow="true"
          :show-footer-overflow="true"
          :pagination="pagination"
          show-summary :summary-object="sumRecord"
          :selectable="notEqSelectable('state', AdProductTargetEnum.SP.status.ARCHIVE)"
          :scroll-y="{mode: 'wheel', oSize:10, gt: 40 }"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSpCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdProductTargetEnum.SP.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdProductTargetEnum.SP.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdProductTargetEnum.SP.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:belongGroup="{row}">
          <app-sp-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sp-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
<!--        <template v-slot:bid="{row}">-->
<!--          {{row.bid | defaultShow(row.currencySymbol)}}-->
<!--        </template>-->
        <template v-slot:bid="{ row }">
          <gj-tooltip :text-line="1">
            <template #content>{{ row.bid | amount | defaultShow(row.currencySymbol) }}</template>
            {{ row.bid | amount | defaultShow(row.currencySymbol) }}
          </gj-tooltip>
          <AdEditBid
            :value="row"
            :isEdit="row.state !== AdProductTargetEnum.SP.status.ARCHIVE && $permission('adsSpCampaigns:addOrUpdate')"
            :currencySymbol="row.currencySymbol"
            :updateValue="updateBid">
          </AdEditBid>
        </template>
        <!-- 建议竞价 -->
        <template v-slot:suggestBid="{ row }">
          <div v-if="!row.resolvedExpressionValueList || row.resolvedExpressionValueList.length == 0 || !row.resolvedExpressionValueList[0] || !getBidType.includes(row.resolvedExpressionValueList[0].type)">-</div>
          <div v-else class="bid-refresh" style="color: #0046f0;">
              <i class="el-icon-refresh" v-if="!row.refresh" @click="bidRefresh(row)" style="cursor: pointer;"></i>
              <i class="el-icon-loading" v-else-if="row.refresh == 1"></i>
              <div v-else-if="row.refresh == 2">
                <div>{{ row.suggested  | defaultShow(row.currencySymbol)}}</div>
                <div style="color: #333">
                  {{ row.rangeStart | defaultShow(row.currencySymbol)}} ~
                  {{ row.rangeEnd | defaultShow(row.currencySymbol)}}
                </div>
              </div>
              <div style="color: #999;" v-else-if="row.refresh == 3">暂无建议</div>
          </div>
        </template>
        <template v-slot:productTargetName="{row}">
          <template v-if="row.resolvedExpressionValueList && row.resolvedExpressionValueList.length > 0">
            <gj-tooltip :text-line="1">
              <template #content>
                <span v-for="(item, i) in row.resolvedExpressionValueList" :key="i" style="padding-right: 5px; text-align: justify;">
                  <template v-if="item.type === 'ASIN_SAME_AS'">
                    商品：<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
                  </template>
                  <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                    {{ item | resolveType }}
                  </template>
                  <template v-else>-</template>
                </span>
              </template>
              <span v-for="(item, i) in row.resolvedExpressionValueList" :key="i" style="padding-right: 5px; text-align: justify;">
                <template v-if="item.type === 'ASIN_SAME_AS'">
                  商品：<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
                </template>
                <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                  {{ item | resolveType }}
                </template>
                <template v-else>-</template>
              </span>
            </gj-tooltip>
          </template>
          <template v-else>-</template>
        </template>
          <template v-slot:strategyStatus="{ row }">
        {{AdStrategyStatusEnum.option[row.strategyStatus].text || row.strategyStatus}}
          <div class="gj-cell-display-switch"  v-if="row.strategyStatus === 0 || row.strategyStatus === 1">
            <gj-tooltip content="编辑">
              <i class="el-icon-edit color999" @click="timeAdjust(row)"></i>
            </gj-tooltip>
            <gj-tooltip content="移除">
              <i class="iconfont iconshanchu size13 color999" style="margin-left: 10px;" @click="deleteEvent(row)"></i>
            </gj-tooltip>
          </div>
          <div class="gj-cell-display-switch"  v-if="row.strategyStatus === 2">
                <gj-button type="text" @click="timeAdjust(row)" >去添加</gj-button>
          </div>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              v-if="row.state === AdProductTargetEnum.SP.status.ARCHIVE || !$permission('adsStrategyObject:add')"
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
          <gj-button-group v-else type="dropdown-op">
             <gj-button type="text" v-if="false" @click="viewAdjustLog(row)">调价日志</gj-button>
              <gj-button type="text" @click="viewLog(row)">操作日志</gj-button>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin,adAdvancedFilteringMixin,
    currencySymbolMixin,
    inCampaignMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin,
    inGroupMixin, resizeMixin, initDateMixin
  } from "../../../common/mixin";
  import {isMeaningfulMixin, queryMixin, responseMixin, selectionMixin} from "@/minxins";
  import AppAdjustBidModal from "../../../common/modal/adjust/adjust-bid-modal";
  import {AdProductTargetEnum, AdStrategyStatusEnum, AdLog, RESOLVED_EXPRESSION_VALUE_MAP} from "../../../common/enum";
  import AppAddSpAdProductTarget from "../../common/modal/add/product-target/add-ad-product-target";
  import {subDays} from 'date-fns';
  import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
  import {convertToDate} from "@/utils/date.util";
  import {adStore} from "../../../common/store";
  import {
    addAdsAdjustStrategy,
    updateAdsAdjustStrategyObject,
    getSpAdProductTargetPage,
    updateSpAdProductTarget,
    updateSpAdProductTargetNew,
    getAdsSpProductTargetingSuggestedBid,
    SP,
    batchUpdateStrategyObject,
    deleteAdsAdjustStrategyTpl,
  } from "@/api/ad";
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
import AppAdLogModal from "../../../common/modal/log/ad-log-new-modal";
  import {LOG_OP_TYPE} from "../../../common/options";
  import AppAdTimeAdjustStrategyOpModal
    from "../../../strategy/time-adjust/modal/strategy-op/time-adjust-strategy-op-modal";
  import {OpEnum} from "@/utils/options";
  import {AdStrategyEnum} from "../../../strategy/common/enum";
  import AdEditBid from "modules/ad/common/components/ad-edit-bid.vue";
  import {getResumeConditionInfo, deleteStrategy} from '../../const'
    import { getAsinInfo } from '@/views/modules/ad/config'

  export default {
    name: "app-sp-ad-product-target",
    components: {AppSpAdRouteLink, AdCampaignSelect, AdGroupSelect, AdEditBid},
    mixins: [
      inMarketMixin, inPortfolioMixin, inGroupMixin, resizeMixin,
      inCampaignMixin, tableNameMixin, selectionMixin,
      adBaseDataMixin, queryMixin, currencySymbolMixin, adAdvancedFilteringMixin,
      isMeaningfulMixin, adDefaultSortMixin, responseMixin, initDateMixin
    ],
    created() {
      this.columns = [
        adFields.status,
        {...adFields.picture, field: 'picture:asinImageUrl'},
        adFields.productTargetName,
        {...adFields.servingStatus, options: AdProductTargetEnum.SP.servingStatusOption},
        {...adFields.strategyStatus, field: 'slot:strategyStatus', options: AdStrategyStatusEnum.option},
        this.inGroup ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        // adFields.creationDate,
        adFields.suggestBid,
        {...adFields.bid, field: 'slot:bid'},
        adFields.originalBid,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        adFields.acos,
        adFields.roas,
        {...adFields.op, width: '110px'},
      ].filter(e => e!== null);
    },
    inject: [ 'getCornerMark' ],
    data() {
      return {
        helpName:'spadmanager',
        lastUpdatedDate: "",
        countryName: '',
        sumRecord: {},
        campaignIds: [],
        groupIds: [],
        tableData: [],
        columns: [],
        AdProductTargetEnum: AdProductTargetEnum,
        AdStrategyStatusEnum: AdStrategyStatusEnum,
        // filter
        filter: {
          status: AdProductTargetEnum.SP.statusNew.ENABLE_PAUSE,
          strategyStatus: null,
          keyword: null,
          extendSearch: null,
          date: [subDays(new Date(), 6), new Date()],
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-sp-ad-product-target',
        getBidType: ['asinSameAs', 'asinCategorySameAs', 'ASIN_SAME_AS' , 'ASIN_CATEGORY_SAME_AS' ], // 能够获取建议竞价的type
        notStorage: true
      }
    },
    filters: {
      resolveType(val) {
        switch (val.type) {
          case 'ASIN_SAME_AS':
            return `商品：${val.value}`;
          case 'ASIN_EXPANDED_FROM':
            return `扩展商品：${val.value}`;
          case 'ASIN_CATEGORY_SAME_AS':
            return `分类：${val.value}`;
          case 'ASIN_PRICE_BETWEEN':
            let sign = val.value.split('-');
            return `价格：${adStore.SP.currencySymbol}${sign[0]}-${adStore.SP.currencySymbol}${sign[1]}`;
          case 'ASIN_BRAND_SAME_AS':
            return `品牌：${val.value}`;
          case 'ASIN_PRICE_LESS_THAN':
            return `价格：低于${adStore.SP.currencySymbol}${val.value}`;
          case 'ASIN_PRICE_GREATER_THAN':
            return `价格：高于${adStore.SP.currencySymbol}${val.value}`;
          case 'ASIN_REVIEW_RATING_LESS_THAN':
            return `星级：低于${val.value}星`;
          case 'ASIN_REVIEW_RATING_BETWEEN':
            let sign1 = val.value.split('-');
            return `星级：${sign1[0]}星-${sign1[1]}星`;
          case 'ASIN_REVIEW_RATING_GREATER_THAN':
            return `星级：高于${val.value}星`;
          case 'ASIN_IS_PRIME_SHIPPING_ELIGIBLE':
            return `配送：${val.value === 'false' ? '不' : ''}具备Prime资格`;
          default:
            break;
        }
        return `${RESOLVED_EXPRESSION_VALUE_MAP[val.type]?.label || val.type || ''}=${val.value}`
      }
    },
    methods: {
      // 投放修改
      async targetsEdit(param) {
        const params = {
          marketId: this.marketId,
          params: param
        }
        try {
          const { data, msg, isError} = await SP.targetsEdit(params);
          this.$gjMessage[isError ? 'error' : 'success'](msg);
          this.clearCheckboxRow();
          data && data.forEach(item => {
            let element = this.tableData.find(e => e.targetId === item.targetId);
            Object.assign(element, item);
          });
        } catch (error) {
          //
        }
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          groupIds: [],
          filter: {
            status: AdProductTargetEnum.SP.statusNew.ENABLE_PAUSE,
            keyword: null,
            strategyStatus: null,
            extendSearch: null,
            date: this.initDate || [subDays(new Date(), 6), new Date()]
          },
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) return false;
        this.getCornerMark();
        this.getTablePage();
      },
      async getTablePage() {
        this.loading = true;
        // 处理广告活动 & 广告组
        let campaignIds = this.campaignIds || [];
        let groupIds = this.groupIds || [];
        this.campaignId && (campaignIds = [ this.campaignId ]);
        this.groupId && (groupIds = [ this.groupId ]);
        // 构造查询参数
        const params = {
          model: {
            campaignIds,
            groupIds,
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            extendSearch: this.filter.extendSearch,
            states: this.filter.status ? JSON.parse(this.filter.status) : null,
            expressionValue: this.filter.keyword,
            strategyStatus: defaultVal(this.filter.strategyStatus, null),
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
            expressionType: '0', // 投放类型：'0'：商品投放，'1'：投放组
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        try {
          let { data } = await SP.targetsPage(params);
          this.sumRecord = data.sumRecord;
          this.lastUpdatedDate = data.lastUpdatedDate;
          this.countryName = data.countryName;
          const tableData = this.currencySymbolMixin(data.records, adStore.SP.currencySymbol);
          this.tableData = tableData;
          this.tableData = this.tableData.map(e => ({
            ...e,
            refresh: null,
            rangeEnd: null,
            rangeStart: null,
            suggested: null,
            recommended: null,
          }))
          getAsinInfo('expressionValue', this.tableData[0].marketId, data.countryCode, this.tableData, 'asinImageUrl');
          this.pagination = this.getPagination(data);
        } catch (error) {
          //
        } finally {
          this.loading = false;
        }
      },
      // 更新竞价
      async updateBid(val, row) {
        const params = [{
          targetId: row.targetId,
          adjustmentType: 0,
          adjustmentValue: val
        }]
        await this.targetsEdit(params);
      },
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.groupIds = []
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions('SP', afferent)
      },
      // 竞价刷新
      async bidRefresh(row) {
        let bidType = row?.resolvedExpressionValueList[0]?.type
        let tableData = this.tableData.filter(e => e.resolvedExpressionValueList[0] && e.resolvedExpressionValueList[0].type == bidType && e.groupId == row.groupId)
        let expressions = tableData.map(e => ([
          {
            ...e.resolvedExpressionValueList[0],
            type: RESOLVED_EXPRESSION_VALUE_MAP[e.resolvedExpressionValueList[0].type]?.hump || e.resolvedExpressionValueList[0].type
          }
        ]))
        tableData.forEach(e => {
          this.$set(e, "refresh", 1)
        });
        let params = {
          targetingParam: {
            adGroupId: row.groupId,
            expressions
          },
          marketId: this.marketId
        }
        try {
          let { data } = await getAdsSpProductTargetingSuggestedBid(params)
          tableData.forEach(e => {
            let item = data.recommendations.find(j => {
              let item2 = j.expression.find(j2 => j2.value.toUpperCase() == e.resolvedExpressionValueList[0].value.toUpperCase())
              if (item2) return j
            })
            if (item) {
              if (item.suggestedBid) {
                this.$set(e, "refresh", 2)
                this.$set(e, "rangeEnd", item.suggestedBid.rangeEnd)
                this.$set(e, "rangeStart", item.suggestedBid.rangeStart)
                this.$set(e, "suggested", item.suggestedBid.suggested)
              }else {
                this.$set(e, "refresh", 3)
              }
            }
          })
        } catch (error) {
          tableData.forEach(e => {
            this.$set(e, "refresh", false)
          })
          console.log(error);
        }
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      // 设置建议竞价弹窗
      adjustBidAddPopup() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: `请确认将选择的<span style="color: red;font-weight: bold;">${this.selectedRows.length}</span>个商品投放竞价调整到建议竞价，更改时只对有建议竞价的对象进行操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              this.adjustBidQuick()
              modal.$gjDestroy()
            }
          }
        });
      },
      // 设置建议竞价
      adjustBidQuick() {
        // 判断是否包含未获取建议竞价的项
        let condition = this.selectedRows.some(e => !e.suggested)
        if (condition) {
          this.$gjMessage.error('请先获取建议竞价')
          let groupIds = this.selectedRows.reduce((arr, current) => {
            let some = arr.some(e => (e.groupId == current.groupId && e?.resolvedExpressionValueList[0]?.type == current?.resolvedExpressionValueList[0]?.type))
            if (!some) { arr.push(current) }
            return arr
          }, [])
          for (const e of groupIds) {
            this.bidRefresh(e)
          }
          return false
        }
        // 正常
        this.loading = true
        SP.targetsEdit({
            marketId: this.marketId,
            params: this.selectedRows.map(e => ({
              campaignId: e.campaignId,
              targetId: e.targetId,
              adjustmentType: 0,
              adjustmentValue: e.suggested
            })),
          })
          .then(({ msg, isError }) => {
            this.$gjMessage[isError ? 'error' : 'success'](msg);
            this.$gjResetPage();
          })
          .complete(() => this.loading = false);
      },
      adjustBid() {
        const modal = this.$gjCreate(AppAdjustBidModal, {
          props: {
            currencySymbol: adStore.SP.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                targetId: e.targetId,
                adjustmentType: modal.form.bid.key,
                adjustmentValue: modal.form.bid.value,
              }))
              try {
                await this.targetsEdit(params);
                modal.$gjDestroy()
              } catch (error) {
                //
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      add() {
        this.$gjCreate(AppAddSpAdProductTarget, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: `已选择 ${rows.length} 个商品投放，确认启用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                targetId: e.targetId,
                state: AdProductTargetEnum.SP.status.ENABLE
              }))
              try {
                await this.targetsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                //
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: `已选择 ${rows.length} 个商品投放，确认停用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                targetId: e.targetId,
                state: AdProductTargetEnum.SP.status.PAUSE
              }))
              try {
                await this.targetsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                //
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                targetId: e.targetId,
                state: AdProductTargetEnum.SP.status.ARCHIVE
              }))
              try {
                await this.targetsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                //
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      viewLog(row) {
        let campaignId = this.campaignId || row?.campaignId;
        let groupId = this.groupId || row?.groupId;
        let objectName = row?.resolvedExpressionValueList[0].value;
        this.$gjCreate(AppAdLogModal, {
          props: {
            campaignId,
            groupId,
            objectName,
            marketId: this.marketId,
            adType: 'SP',
            objectType: AdLog().objCell.delivery,
          }
        });
        // this.$gjCreate(AppAdLogModal, {
        //   props: {
        //     marketId: this.marketId,
        //     campaignId: this.campaignId,
        //     groupId: this.groupId,
        //     name: '',
        //     opId: isMeaningful(row) ? row.targetId : null,
        //     adType: LOG_OP_TYPE.SP,
        //     object: LOG_OP_TYPE.SP.PRODUCT_TARGET
        //   }
        // });
      },
      // 广告策略
      timeAdjust(row) {
        let title = '<span>分时策略</span>';
        if (isMeaningful(row.expressionValue)) {
          title = `${title}<span class="modal-secondary-title">(${row.expressionValue})</span>`;
        }
        const modal = this.$gjCreate(AppAdTimeAdjustStrategyOpModal, {
          props: {
            title,
            opType: OpEnum.type.USE,
            item: row,
            objectId: row.objectId,
            strategyType: 1,// 1：广告组、关键词、商品投放、投放组， 2：广告位， 3：广告活动
          },
          on: {
            updated: () => {
              this.$gjMessage.success('操作成功');
              modal.$gjDestroy();
              this.$gjResetPage()
            },
            useStrategy: ({params, status, templateId, callback, resumeDTO}) => {
              modal.confirmLoading = true;
              let useParams;
              Promise.resolve(row.strategyStatus)
                      .then((strategyStatus) => {
                        if (strategyStatus === AdStrategyStatusEnum.NO_ADD) {
                          useParams = {
                            resumeDTO,
                            id: row.objectId,
                            adsStrategyTemplate: params,
                            marketId: row.marketId,
                            bid: row.bid,
                            status,
                            templateId,
                            campaignId: row.campaignId,
                            campaignName: row.campaignName,
                            groupId: row.groupId,
                            groupName: row.groupName,
                            objectId: row.targetId,
                            objectName: row.expressionValue,
                            objectType: AdStrategyEnum.objectType.PRODUCT_TARGET
                          }
                          return addAdsAdjustStrategy(useParams)
                        } else {
                          useParams = [{
                            ...params,
                            marketId: row.marketId,
                            objectPid: row.objectId,
                            objectStatus: status,
                            templatePId:templateId,
                          }]
                          return batchUpdateStrategyObject(useParams)
                        }
                      })
                      .then((res) => {
                        if (callback) {
                          callback(res);
                        }
                      })
                .complete(() => modal.confirmLoading = false);
            }
          }
        })
      },
      viewAdjustLog(row) {

      },
             // 移除，二次确认
    deleteEvent(row) {
      deleteStrategy(this, row);
      // const modal = this.$gjCreate('gj-info-modal', {
      //   props: {
      //     title: '移除确认',
      //     content: `确定要移除分时策略吗？请谨慎操作！`
      //   },
      //   on: {
      //     cancel: () => modal.$gjDestroy(),
      //     confirm: () => {
      //       modal.confirmLoading = true;
      //        getResumeConditionInfo(row.objectId, row, (res) => {
      //           modal.confirmLoading = false
      //           if (res === 'success') {
      //             this.$gjMessage.success('移除成功');
      //             this.$gjResetPage();
      //             modal.$gjDestroy();
      //           }else {
      //             this.$gjMessage.success('移除失败，请稍后重试');
      //           }

      //         })
      //     }
      //   }
      // });

    },
    }
  }
</script>

<style scoped>

</style>
